import {Api, HTTPMethod, buildExport} from "@next/apiconfig"
import {SEARCH_CATEGORY_SEGMENT} from "../../constants"
import env from "../../env"

const {REACT_APP_API_BASEURL_SEARCH, ASSETS_PATH} = env
export class ProductsApi implements Api {
    baseURL = `${REACT_APP_API_BASEURL_SEARCH}`
    version = "v1"
    endpoints = {
        getProducts: {
            routeDefinition: `${env.REACT_APP_SERVE_PATH_PREFIX}/products`,
            getLocalURL: () => `${env.REACT_APP_SERVE_PATH_PREFIX}/products`,
            getRemoteURL: () => `/item-numbers`,
            method: HTTPMethod.get,
        },
        getProductsFragment: {
            routeDefinition: `${env.REACT_APP_SERVE_PATH_PREFIX}/products-fragment`,
            getLocalURL: () => `${env.REACT_APP_SERVE_PATH_PREFIX}/products-fragment`,
            getRemoteURL: () => `/item-numbers`,
            method: HTTPMethod.get,
        },
        getProductFragmentsById: {
            routeDefinition: `${env.REACT_APP_SERVE_PATH_PREFIX}/fragments-by-cached-ids`,
            getLocalURL: () => `${env.REACT_APP_SERVE_PATH_PREFIX}/fragments-by-cached-ids`,
            getRemoteURL: () => `/no_remote_url_needed`,
            method: HTTPMethod.get,
        },
        getStaticProductFragmentsById: {
            routeDefinition: `${env.REACT_APP_SERVE_PATH_PREFIX}/static-fragments-by-cached-ids`,
            getLocalURL: () => `${env.REACT_APP_SERVE_PATH_PREFIX}/static-fragments-by-cached-ids`,
            getRemoteURL: () => `/no_remote_url_needed`,
            method: HTTPMethod.get,
        },
        // on click of filters or back to top
        getSearchResults: {
            routeDefinition: `${env.REACT_APP_SERVE_PATH_PREFIX}/plp-ui/api/v1/search`,
            getLocalURL: (apiProxyVersion: string) =>
                `${env.REACT_APP_SERVE_PATH_PREFIX}/plp-ui/api/${apiProxyVersion}/search`,
            getRemoteURL: () => `/item-numbers`,
            method: HTTPMethod.get,
        },
        // on scroll of page
        getProductSummaryAggregation: {
            routeDefinition: `${env.REACT_APP_SERVE_PATH_PREFIX}/plp-ui/api/v1/product-summary-aggregator`,
            getLocalURL: (apiProxyVersion: string) =>
                `${env.REACT_APP_SERVE_PATH_PREFIX}/plp-ui/api/${apiProxyVersion}/product-summary-aggregator`,
            getRemoteURL: () => `/no_remote_url_needed`,
            method: HTTPMethod.get,
        },
        getSeoData: {
            routeDefinition: `${ASSETS_PATH}/seo-filters/${SEARCH_CATEGORY_SEGMENT}/:page/:filters?`,
            getLocalURL: () => "",
            getRemoteURL: () => `/item-numbers`,
            method: HTTPMethod.get,
        },
    }
}

const searchApi = new ProductsApi()
export default (endpoint: keyof typeof searchApi.endpoints) => buildExport(searchApi, endpoint)
